import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button } from '@mui/material';
import SurveyAdminService from '../../../../shared/services/survey/survey-admin.service';

interface Props {
  groupId: string;
}

/**
 * Warns when the question set being edited is shared: changes made from this
 * survey apply to every survey using the set.
 */
export const SharedSetBanner = ({ groupId }: Props) => {
  const navigate = useNavigate();
  const [usageCount, setUsageCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    SurveyAdminService.getInstance()
      .getSurveys({ surveyQuestionGroupId: groupId, page: 0, perPage: 1 })
      .then(result => { if (!cancelled) setUsageCount(result.count); })
      .catch(() => { if (!cancelled) setUsageCount(null); });
    return () => { cancelled = true; };
  }, [groupId]);

  if (usageCount == null || usageCount <= 1) return null;

  return (
    <Alert
      severity='info'
      sx={{ mb: 2 }}
      action={(
        <Button color='inherit' size='small' onClick={() => navigate(`/surveys/question-groups/${groupId}`)}>
          Open question set
        </Button>
      )}
    >
      This question set is shared by {usageCount} surveys. Changes made here apply to all of them.
    </Alert>
  );
};
